// @flow
import PrimaryPalette from '../../colors';
import {
  ChipText,
  DangerChipText,
  UnavailableChipText,
} from '../../internal/internal-typography';
import type { Color } from '../../colors';

export type ChipTheme = {
  theme: {
    typography: any,
    hoverBorderColor: Color,
    backgroundColor: Color,
    borderColor: Color,
    closeIcon: {
      backgroundColor: Color,
      hoverBackgroundColor: Color,
    },
  },
};

export const CloseIconTheme = {
  default: {
    backgroundColor: PrimaryPalette.lightGrey,
    color: PrimaryPalette.mediumEvergreen,
  },
  hover: {
    backgroundColor: PrimaryPalette.darkerGrey,
    color: PrimaryPalette.lightGrey,
  },
};

const Theme = {
  default: {
    typography: ChipText,
    hoverBorderColor: PrimaryPalette.darkGrey,
    backgroundColor: PrimaryPalette.lightGrey,
    borderColor: PrimaryPalette.lightGrey,
  },
  error: {
    typography: DangerChipText,
    hoverBorderColor: PrimaryPalette.darkPoppy,
    backgroundColor: PrimaryPalette.lightGrey,
    borderColor: PrimaryPalette.lightGrey,
  },
  unavailable: {
    typography: UnavailableChipText,
    hoverBorderColor: PrimaryPalette.darkGrey,
    backgroundColor: PrimaryPalette.lightGrey,
    borderColor: PrimaryPalette.lightGrey,
  },
  hover: {
    typography: ChipText,
    hoverBorderColor: PrimaryPalette.darkGrey,
    backgroundColor: PrimaryPalette.lightGrey,
    borderColor: PrimaryPalette.lightGrey,
  },
};

export default Theme;
